import { render, staticRenderFns } from "./checkProduct.vue?vue&type=template&id=2cf7768b&scoped=true"
import script from "./checkProduct.vue?vue&type=script&lang=js"
export * from "./checkProduct.vue?vue&type=script&lang=js"
import style0 from "./checkProduct.vue?vue&type=style&index=0&id=2cf7768b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf7768b",
  null
  
)

export default component.exports